export default __webpack_public_path__ + "static/media/logo.1bf2df43.png";